import Vue from 'vue';
const { default: constants } = require('../../../plugins/constants');

export default {
    namespaced: true,
    state: {
        menu: [
            { product: true, title: constants.BOT_NAME+'s', bgcolor: 'primary' },
            {
                title: 'All Projects', icon: '/img/navicon/AllProjects.svg', href: '/bot/project',
            },
            {
                title: 'Input Parameters Config', icon: '/img/navicon/InputParametersConfig.svg', href: '/bot/ipconfig',
            },
            {
                title: 'File Master ', icon: '/img/navicon/FileMaster.svg', href: '/bot/filemaster',
            },
            {
                title: 'File Config ', icon: '/img/navicon/FileConfig.svg', href: '/bot/filelist',
            },
            {
                title: 'Queries', icon: '/img/navicon/Queries.svg', href: '/bot/queries',
            },
        ],
        fileMasters: [],
        fileMasterConfigLoading: false,
    },
    mutations: {
        SET_FILE_MASTERS(state, data) {
            state.fileMasters = data;
        },
        SET_FILE_MASTER_CONFIG_LOADING(state, val) {
            state.fileMasterConfigLoading = val;
        },
    },
    actions: {
        async fetchFileMasters({ commit }) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post('/v2/conserve/filemaster/get');
                if (response.data.status === 'success') {
                    commit('SET_FILE_MASTERS', response.data.data);
                }
                return response.data;
            } catch (error) {
                console.error('[BotStore]: fetchFileMasters error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to fetch file masters', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
        async fetchFileConfig({ commit }, id) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post(`/v2/conserve/fileconfig/get/${id}`);
                return response.data;
            } catch (error) {
                console.error('[BotStore]: fetchFileConfig error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to fetch file config', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
        async addFileConfig({ commit }, payload) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post('/v2/conserve/fileconfig/add/', { data: payload });
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'File configuration added successfully', { root: true });
                }
                return response.data;
            } catch (error) {
                console.error('[BotStore]: addFileConfig error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to add file config', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
        async addFileConfigV2({ commit }, payload) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post('/v2/conserve/fileconfig/v2/add', { data: payload });
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'File configuration (v2) added successfully', { root: true });
                }
                return response.data;
            } catch (error) {
                console.error('[BotStore]: addFileConfigV2 error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to add v2 file config', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
        async editFileConfig({ commit }, { id, payload }) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post('/v2/conserve/fileconfig/edit/' + id, { data: payload });
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'File configuration updated successfully', { root: true });
                }
                return response.data;
            } catch (error) {
                console.error('[BotStore]: editFileConfig error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to update file config', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
        async editFileConfigV2({ commit }, { id, payload }) {
            try {
                commit('SET_FILE_MASTER_CONFIG_LOADING', true);
                const response = await Vue.axios.post('/v2/conserve/fileconfig/v2/edit/' + id, { data: payload });
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'File configuration (v2) updated successfully', { root: true });
                }
                return response.data;
            } catch (error) {
                console.error('[BotStore]: editFileConfigV2 error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to update v2 file config', { root: true });
                throw error;
            } finally {
                commit('SET_FILE_MASTER_CONFIG_LOADING', false);
            }
        },
    },
    getters: {
        fileMasters: (state) => state.fileMasters,
        fileMasterConfigLoading: (state) => state.fileMasterConfigLoading,
    },
}